import { get, post, patch } from "../../../shared/data";

export const mapToReferenceProduct = (r) => {
    const clientAttribute = r.attributes["5666110124393498670"];
    const modifierAttribute = r.attributes["1880918225320709"];
    const postDateAttribute = r.attributes["2766130833128377878"];
    const legacyDataSourceAttribute = r.attributes["692390325209869486"];
    const shipmentTypeAttribute = r.attributes["4920955993844657152"];
    const frontImage = r.images.find(({ cxhAssetName }) => cxhAssetName === "Front");

    return {
        referenceProductId: r.productId,
        referenceImageId: frontImage ? frontImage.cxHImageAttributeValue : "",
        cvid: r.cvid,
        isRetailer: clientAttribute && clientAttribute.value ? clientAttribute.value.isRetailer : false,
        modifier: modifierAttribute && modifierAttribute.value ? modifierAttribute.value : null,
        postDate: postDateAttribute && postDateAttribute.value ? postDateAttribute.value : null,
        legacyDataSource: legacyDataSourceAttribute && legacyDataSourceAttribute.value ? legacyDataSourceAttribute.value : null,
        shipmentType: shipmentTypeAttribute && shipmentTypeAttribute.value ? shipmentTypeAttribute.value : null,
    };
};

export const addRedoTask = (key, task, sourcePage) => {
    const url = `/receiving/final/${key}/re-${task}?sourcePage=${sourcePage}`;

    return post(url);
};

export const getLinked = (shipmentKey) => {
    // {
    //     "upc": "string",
    //     "isDamaged": true,
    //     "notes": "string",
    //     "binTrackingNumber": "string",
    //     "generateUpc": true,
    //     "key": "string",
    //     "createdBy": "string",
    //     "createdOn": "2018-03-16T20:46:04.441Z",
    //     "updatedBy": "string",
    //     "updatedOn": "2018-03-16T20:46:04.441Z"
    //   }
    return get(`/receiving/shipments/${shipmentKey}/products`).then((response) => {
        return response;
    });
};

export const sendMatchData = (codingKey, matchType, matches, shouldUpdateCorrelationId = false) => {
    /*
    {
        type: 4,
        matchingProducts: [{
            "referenceProductId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            "referenceImageId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        }]
    }
    */
    const payload = {
        type: matchType,
        matchingProducts: matches,
        isCorrelationIdUpdate: shouldUpdateCorrelationId,
    };

    return patch(`/coding/wips/${codingKey}/product-match`, payload);
};

export const validateMatchV2 = (codingKey, matchType, matches, hasUserConfirmedOverridableErrors) => {
    const payload = {
        type: matchType,
        matchingProducts: matches,
        hasUserConfirmedOverridableErrors: hasUserConfirmedOverridableErrors,
    };

    return post(`/product-match/${codingKey}/validate/v2`, payload);
};
